import { Box } from '@mui/material';
import React from 'react';
import { ContentHeadingProps } from '../../../models/TopLevelTemplateComponentProps';
import { headingNotSet, tagNotSet } from '../../../services/TemplateUtils';
import InlineText from './InlineText';
import { webSectionHeadingSx, webTagSx } from './webTextStyles';

interface InlineSectionHeaderProps {
  heading: ContentHeadingProps | undefined;
  onChange: (heading: ContentHeadingProps) => void;
  /** Right-aligned control slot (the block's Paste button), same spot on every block. */
  action?: React.ReactNode;
}

/**
 * The tag + heading pair shared by every v2 block editor. The tag is the short
 * filter label for the section on the investor page (it falls back to the
 * heading when blank — see `tagOrHeading` / `FundOpportunityEOIFilters`).
 */
export default function InlineSectionHeader({
  heading,
  onChange,
  action,
}: InlineSectionHeaderProps) {
  const base: ContentHeadingProps = heading ?? { id: '', content: '' };

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, flex: 1, minWidth: 0 }}>
        <InlineText
          value={heading?.tag ?? ''}
          unset={tagNotSet(heading)}
          onChange={(value) => onChange({ ...base, tag: value })}
          placeholder="Add a filter label"
          ariaLabel="Filter label"
          sx={webTagSx}
        />
        <InlineText
          value={heading?.content ?? ''}
          unset={headingNotSet(heading)}
          onChange={(value) => onChange({ ...base, content: value })}
          placeholder="Add a section heading"
          ariaLabel="Section heading"
          sx={webSectionHeadingSx}
        />
      </Box>
      {action}
    </Box>
  );
}
